const lang = {
  contact: 'Contacto',
  experience: 'Experiencia',
  education: 'Educación',
  skills: 'Habilidades',
  about: 'Sobre mi'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/es.js